const initialState = {
    isModalVisible: false,
  };
  
  const settingsModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_SETTINGS_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_SETTINGS_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default settingsModalReducer;
  